import { UPDATE_PROFILE, GET_PROFILE } from '../actions/profile';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  userProfile: {},
};

const userProfileReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case UPDATE_PROFILE.REQUEST:
    case GET_PROFILE.REQUEST: {
      return { ...state, isLoading: true };
    }

    case UPDATE_PROFILE.SUCCESS: {
      toast.success('Profile updated successfully');
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      return { ...state, userProfile: payload, isLoading: false };
    }

    case GET_PROFILE.SUCCESS: {
      return {
        ...state,
        userProfile: payload,
        isLoading: false,
      };
    }

    case UPDATE_PROFILE.FAIL:
    case GET_PROFILE.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default userProfileReducer;
